import { useContext, useEffect, useState } from "react";
import { Avatar, Button, CssBaseline, TextField, Box, Typography, Container, FormControl, InputLabel, OutlinedInput, InputAdornment, IconButton, CircularProgress, Menu, MenuItem, Divider } from '@mui/material'
import { Visibility, VisibilityOff, Email as EmailIcon, Lock as LockIcon, Settings as SettingsIcon, Google as GoogleIcon } from "@mui/icons-material";
import QrCodeIcon from '@mui/icons-material/QrCode';
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import ReCAPTCHA from 'react-google-recaptcha'
import { useTranslation } from "react-i18next";
import { AuthContext } from 'context/AuthContext'
import ValidationSchema from "./services/SchemaValidation"
import { SnackbarGlobal } from 'components/Snackbar'
import { useMutation } from "react-query";
import { loginRegister, loginGoogleRegister } from "./services/api/Auth";
import { Link, useNavigate } from 'react-router-dom'
import i18n from "i18next";
import { auth, signInWithGoogle } from "../../firebase";
import { FMPageOpacityTransition } from "components/FMTransitions/PageTransitions";
import { StrengthMeter } from "components/StrengthMeter";

export default function Register() {
  const { t } = useTranslation();
  const { activateAuth, loadUser, loadToken, isAuth } = useContext(AuthContext)
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false);
  const [authError, setAuthError] = useState(false);
  const [messageSnackbar, setMessageSnackbar] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [recaptcha, setRecaptcha] = useState(null);
  const [company, setCompany] = useState(null);
  const [password, setPassword] = useState("");
  const [strengthPassword, setStrengthPassword] = useState(false);
  const [showOptionsRegister, setShowOptionsRegister] = useState(false);
  let { handleSubmit, register, formState: { errors } } = useForm({ resolver: yupResolver(ValidationSchema) })


  useEffect(() => {
    if (isAuth) { navigate("/admin/dashboard") }
  })

  const mutation = useMutation(loginRegister, {
    onSuccess: (data) => {
      setIsLoading(false)
      if (data.status === "error") {
        setMessageSnackbar('Correo y/o contraseña incorrectos');
        setAuthError(true);
      } else if (data.status === "user_exist") {
        setMessageSnackbar('El usuario ya existe');
        setAuthError(true);
      } else {
        loadUser(JSON.stringify(data.user))
        loadToken(data.token)
        activateAuth()
        navigate("/admin/account")
      }
    }
  })

  const mutationGoogle = useMutation(loginGoogleRegister, {
    onSuccess: (data) => {
      setIsLoading(false)
      if (data.status === "error") {
        setMessageSnackbar('Correo y/o contraseña incorrectos');
        setAuthError(true);
      } else if (data.status === "user_exist") {
        setMessageSnackbar('El usuario ya existe');
        setAuthError(true);
      } else {
        loadUser(JSON.stringify(data.user))
        loadToken(data.token)
        activateAuth()
        navigate("/admin/account")
      }
    }
  })

  const onSubmit = (params) => { //console.log("Params:", JSON.stringify(params))
    if (recaptcha == null) {
      setMessageSnackbar('Es necesario marcar el captcha');
      setAuthError(true); return;
    }
    setIsLoading(true)
    mutation.mutate({ data: params, companyName: company })
  }

  const onSubmitGoogle = async () => {
    await signInWithGoogle()
    auth.currentUser.getIdToken().then(async (idToken) => {
      console.log(idToken)
      setIsLoading(true)
      mutationGoogle.mutate({ idToken: idToken, companyName: company })
      //let loginGoogleRes = await loginGoogleRegister({ idToken: idToken, companyName: company })
      //console.log("loginGoogleRes", loginGoogleRes)
    }).catch(function (error) {
      console.error(error);
    });
  }

  const handleClickShowPassword = () => { setShowPassword(!showPassword) }
  const handleMouseDownPassword = (event) => { event.preventDefault() }
  function onChangeRecaptcha(value) { setRecaptcha(value) }

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => { setAnchorEl(event.currentTarget); };
  const handleClose = () => { setAnchorEl(null); };

  const changeLanguage = (lng) => { i18n.changeLanguage(lng); }

  const handleCompanyChange = (e) => {
    const { value } = e.target
    setCompany(value)
    if (value !== null && value !== "" && value.length > 3) {
      setShowOptionsRegister(true)
    } else { setShowOptionsRegister(false) }
  }

  return (<FMPageOpacityTransition>
    <Container style={{ maxWidth: "100%", paddingLeft: 0, paddingRight: 0, height: "100vh" }}>
      <CssBaseline />
      <Box sx={{ padding: 3 }} >
        <div style={{ display: "flex", alignItems: "center", justifyContent: "end", marginBottom: 16 }}>
          <div style={{ textAlign: "center", marginTop: 8 }}>
            {t('register_already_account_text')} &nbsp; <Button variant="outlined" component={Link} to="/">{t('register_already_account_button')}</Button>
          </div>
          <div style={{ textAlign: "right" }}>
            <IconButton
              onClick={handleClick}
              size="small"
              color="inherit"
              sx={{ ml: 2 }}
              aria-controls={open ? 'account-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={open ? 'true' : undefined}
            >
              <SettingsIcon />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              id="account-menu"
              open={open}
              onClose={handleClose}
              onClick={handleClose}
              PaperProps={{
                elevation: 0,
                sx: {
                  overflow: 'visible',
                  filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                  mt: 1.5,
                  '& .MuiAvatar-root': {
                    width: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 1,
                  },
                  '&:before': {
                    content: '""',
                    display: 'block',
                    position: 'absolute',
                    top: 0,
                    right: 12,
                    width: 10,
                    height: 10,
                    bgcolor: 'background.paper',
                    transform: 'translateY(-50%) rotate(45deg)',
                    zIndex: 0,
                  },
                },
              }}
              transformOrigin={{ horizontal: 'right', vertical: 'top' }}
              anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
              {i18n.language === "en" ?
                <MenuItem onClick={() => changeLanguage('es')}>
                  <Avatar alt="Spanish" src="/spanish_flat.png" /> Español
                </MenuItem>
                : null}
              {i18n.language === "es" ?
                <MenuItem onClick={() => changeLanguage('en')}>
                  <Avatar alt="English" src="/english_flat.png" /> Inglés
                </MenuItem>
                : null}
            </Menu>
          </div>
        </div>
        <div style={{ maxWidth: 403, margin: "0 auto" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Avatar sx={{ m: 1, bgcolor: "primary.main" }}> <QrCodeIcon /> </Avatar>
            <Typography component="h1" variant="h5" sx={{ fontWeight: "bold", fontSize: 30 }}> {t("register_page_title")} </Typography>
          </div>
          <Typography component="p" variant="body1"> {t("register_page_subtitle")} </Typography>

          <Box sx={{ mt: 2, marginBottom: 2 }}>
            <InputLabel htmlFor="company" required style={{ fontSize: 16 }}>{t("register_form_company")}</InputLabel>
            <TextField required fullWidth autoFocus margin="normal" size="small" name="company"
              style={{ marginTop: 8 }} onChange={handleCompanyChange}
            />
          </Box>

          {showOptionsRegister ? <>
            <Box sx={{ mt: 2, marginBottom: 2 }}>
              <InputLabel htmlFor="email" required style={{ fontSize: 16 }}>{t("register_form_email")}</InputLabel>
              <TextField required fullWidth margin="normal" size="small" name="email"
                {...register("email")}
                error={errors.email ? true : false}
                style={{ marginTop: 8 }}
                InputProps={{
                  startAdornment: <InputAdornment position="start"><EmailIcon fontSize="small" /></InputAdornment>,
                }}
              />
              <InputLabel htmlFor="password" required style={{ fontSize: 16, marginTop: 14 }}>{t("register_form_password")}</InputLabel>
              <FormControl variant="outlined" fullWidth margin="normal" required style={{ marginTop: 8, marginBottom: 16 }}>
                <OutlinedInput required fullWidth size="small" type={showPassword ? 'text' : 'password'} name="password"
                  {...register("password")}
                  onChange={(e) => setPassword(e.target.value)}
                  error={errors.password ? true : false}
                  startAdornment={<InputAdornment position="start"><LockIcon fontSize="small" /></InputAdornment>}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton aria-label="toggle password visibility" edge="end"
                        onClick={handleClickShowPassword} onMouseDown={handleMouseDownPassword}
                      > {showPassword ? <Visibility fontSize="small" /> : <VisibilityOff fontSize="small" />} </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>
              <StrengthMeter value={password} isStrength={setStrengthPassword} />

              <br /> <ReCAPTCHA id="recaptcha" sitekey="6LemSy8bAAAAABqOAmOu9I6-L2ME8FPAm0ogNcA2" onChange={onChangeRecaptcha} hl="en" /> <br />
              {(recaptcha !== null && strengthPassword) && <>
                {!isLoading ?
                  <Button onClick={handleSubmit(onSubmit)} fullWidth variant="contained" color="primary"> {t("register_form_button")} </Button>
                  : <CircularProgress />}
              </>}
            </Box>
            <Divider>{t("register_form_divider_options")}</Divider>
            <Button onClick={onSubmitGoogle} fullWidth variant="contained" color="primary" style={{ marginTop: 16, marginBottom: 16 }}>
              <GoogleIcon /> &nbsp; {t("register_form_signin_google_button")}
            </Button>
          </> : null}
        </div>
      </Box>
    </Container>
    <SnackbarGlobal vertical='bottom' horizontal='center' open={authError} close={() => setAuthError(false)} message={messageSnackbar} />
  </FMPageOpacityTransition>);
}